import { render, staticRenderFns } from "./pondRecovery.vue?vue&type=template&id=06c67762"
import script from "./pondRecovery.vue?vue&type=script&lang=js"
export * from "./pondRecovery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports